export default {
  title: 'Edit goal',
  backButton: 'All goals',
};
